export default __webpack_public_path__ + "css/paymentMethodEditor.bundle.css";